const FORM_NAME_BASES = [
  'Darbuotojų apklausa',
  'Organizacijos atstovės/-o apklausa',
];

/**
 * Translates known form names regardless of the suffix coming from the DB (e.g. years).
 * Falls back to the original string if no translation is available.
 */
export const translateFormName = (name, t) => {
  if (!name) {
    return '';
  }

  const trimmedName = name.trim();

  for (const base of FORM_NAME_BASES) {
    if (trimmedName.startsWith(base)) {
      const translatedBase = t(base);
      return translatedBase || base;
    }
  }

  const translated = t(trimmedName);
  return translated || trimmedName;
};

